module.exports = __webpack_public_path__ + "img/Lee_Street_Part_2_0023.8838befc.jpg";